import { CityLocation } from '@petconsole/pure-base';

const ourLocationToCity = (location: CityLocation) => {
  const { city, province, country } = location || {};

  return [city, province, country].filter((x) => !!x).join(', ');
};

export default ourLocationToCity;
